
import NotificationContextProvider from './NotificationContext';
import LanguageContextProvider from './LanguageContext';
import AuthContextProvider from './AuthContext';
import EnvironmentContextProvider from './EnvironmentContext';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import ptBr from 'dayjs/locale/pt-br';


const MainContextProvider = (props: React.PropsWithChildren) => {
    return (
        <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale={ptBr}>
            <LanguageContextProvider>
                <EnvironmentContextProvider>
                    <NotificationContextProvider>
                        <AuthContextProvider>
                            {props.children}
                        </AuthContextProvider>
                    </NotificationContextProvider>
                </EnvironmentContextProvider>
            </LanguageContextProvider>
        </LocalizationProvider>
    );
}


export default MainContextProvider;